/**
 * Content Routes
 *
 * Routes for products, AI services, about, and careers
 */

import React from "react";
import { Route } from "react-router-dom";
import {
  ProductViewer,
  AIServiceViewer,
  AboutUs,
  JobViewer,
  PrivacyPolicyPage,
  TermsOfServicePage,
  CookiePolicyPage,
  GdprPage,
} from "../lazyComponents";
import { getCommonProps } from "./routeConfig";

/**
 * Creates viewer routes (list and detail) for a component
 * @param {string} key - Route key prefix
 * @param {string} basePath - Base path for routes
 * @param {Object} Component - Component to render
 * @param {Object} componentProps - Props to pass to component
 * @returns {Array} Array of Route elements
 */
const createViewerRoutes = (key, basePath, Component, componentProps) => [
  <Route
    key={`${key}-list`}
    path={basePath}
    element={<Component {...componentProps} {...getCommonProps()} />}
  />,
  <Route
    key={`${key}-detail`}
    path={`${basePath}/:${key}Slug`}
    element={<Component {...componentProps} {...getCommonProps()} />}
  />,
];

/**
 * Gets all content-related routes
 * @param {Object} props - Props from parent component
 * @returns {Array} Array of Route elements
 */
export const getContentRoutes = ({ getComponentProps }) => {
  const componentProps = getComponentProps();

  return [
    // Products routes
    ...createViewerRoutes(
      "product",
      "/products",
      ProductViewer,
      componentProps,
    ),

    // AI Services routes
    ...createViewerRoutes(
      "service",
      "/ai-services",
      AIServiceViewer,
      componentProps,
    ),

    // About Us
    <Route
      key="about"
      path="/about"
      element={<AboutUs {...componentProps} {...getCommonProps()} />}
    />,

    // Legal pages
    <Route
      key="privacy-policy"
      path="/privacy-policy"
      element={<PrivacyPolicyPage {...componentProps} {...getCommonProps()} />}
    />,
    <Route
      key="terms-of-service"
      path="/terms-of-service"
      element={
        <TermsOfServicePage {...componentProps} {...getCommonProps()} />
      }
    />,
    <Route
      key="cookie-policy"
      path="/cookie-policy"
      element={<CookiePolicyPage {...componentProps} {...getCommonProps()} />}
    />,
    <Route
      key="gdpr"
      path="/gdpr"
      element={<GdprPage {...componentProps} {...getCommonProps()} />}
    />,

    // Careers routes
    ...createViewerRoutes("job", "/careers", JobViewer, componentProps),
  ];
};
